import { Typography } from "@mui/material";

import styled from "styled-components";

import { isSmallDesktop } from "@/hooks/layout";

export const Logo = styled.img`
  width: 92px;
  height: auto;

  /* phone: shrink the logo so the form's button + "already have an account"
     link fit without scrolling */
  @media (max-width: 600px) {
    width: 46px;
  }
`;

export const DialogTitleTypography = styled(Typography)`
  color: #ffffff;
  font-family: "Cormorant Garamond", serif;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;

  ${isSmallDesktop} {
    font-size: 2.4rem;
  }

  /* phone: smaller heading to reclaim vertical space */
  @media (max-width: 600px) {
    font-size: 1.55rem;
  }
`;

export const HaveAnAccountTypography = styled.p`
  color: #9cd3fd;
  font-family: "Raleway", sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;

  a, button, .MuiLink-root {
    color: inherit !important;
    cursor: pointer;
  }
`;

export const DescriptionTypography = styled(Typography)`
  color: #e0d2c1;
  text-align: center;
  font-family: "Raleway", sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.6;

  strong {
    color: #fbf4ec;
    font-weight: 500;
  }
`;

/* ── Auth Slider ── */

export const AuthSliderViewport = styled.div`
  overflow: hidden;
  transition: height 0.4s ease;
`;

export const AuthSliderTrack = styled.div<{ $step: number; $skip?: boolean }>`
  display: flex;
  width: 500%;
  transform: translateX(${({ $step }) => -$step * 20}%);
  transition: ${({ $skip }) => ($skip ? "none" : "transform 0.4s ease")};
`;

export const AuthSlidePanel = styled.div`
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  align-self: flex-start;
`;
